import { type BreadcrumbItem } from '@graftcode/design-system'

import styles from './buildBreadcrumbs.module.scss'

const getCountSuffix = (isActive: boolean, childrenCount?: number) => {
  const hasCount = typeof childrenCount === 'number'
  if (!isActive || !hasCount) return undefined

  return <span className={styles.after}>({childrenCount})</span>
}

export const buildBreadcrumbs = (
  gateway: string,
  libraryName?: string,
  className?: string,
  classLabel?: string,
  childrenCount?: number,
  projectName?: string,
  libraryLabel?: string
): BreadcrumbItem[] => {
  const rootLabel = projectName || gateway
  const isRootLevel = !libraryName
  const isLibraryLevel = !!libraryName && !className
  const isClassLevel = !!className

  return [
    {
      text: rootLabel,
      url: '#',
      active: isRootLevel,
      after: getCountSuffix(isRootLevel, childrenCount),
    },
    ...(libraryName
      ? [
          {
            text: libraryLabel ?? libraryName,
            url: `#${libraryName}`,
            active: isLibraryLevel,
            after: getCountSuffix(isLibraryLevel, childrenCount),
          },
        ]
      : []),
    ...(className
      ? [
          {
            text: classLabel ?? className,
            url: libraryName ? `#${libraryName}/${className}` : `#${className}`,
            active: isClassLevel,
            after: getCountSuffix(isClassLevel, childrenCount),
          },
        ]
      : []),
  ]
}
